import React from 'react';
import { ArrowRight } from 'lucide-react';

export const DestinationCard = ({ destination, index }) => {
  return (
    <div 
      className="relative min-w-[350px] h-[500px] rounded-3xl overflow-hidden group cursor-pointer transition-all duration-700 transform hover:scale-105"
      style={{
        animationDelay: `${index * 150}ms`
      }}
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
        style={{
          backgroundImage: `url(${destination.image})`
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/20 to-transparent group-hover:from-navy/70 transition-all duration-500" />
      
      {/* Gold Accent Overlay on Hover */}
      <div className="absolute inset-0 bg-gradient-to-t from-amber-400/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      
      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-8">
        <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
          <h3 className="font-serif text-3xl text-white mb-2 group-hover:text-amber-400 transition-colors duration-300">
            {destination.name}
          </h3>
          <p className="text-sand/90 text-sm mb-3 font-light">
            {destination.country}
          </p>
          <p className="text-white/80 text-sm leading-relaxed mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200">
            {destination.description}
          </p>
          <div className="flex items-center gap-2 text-amber-400 opacity-0 group-hover:opacity-100 transition-all duration-500 delay-300">
            <span className="text-sm font-medium">Explore Destination</span>
            <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" />
          </div>
        </div>
      </div>
      
      {/* Luxury Badge */}
      <div className="absolute top-6 right-6">
        <div className="bg-amber-400/90 backdrop-blur-sm text-navy px-3 py-1 rounded-full text-xs font-semibold tracking-wide">
          EXCLUSIVE
        </div>
      </div>
    </div>
  );
};